import * as React from "react";
import DatePicker from "react-datepicker";
import "./datePickerWithIcon.scss";
import "./datePickerOverrides.scss";
import IconWrapper from "../../atoms/Icon/IconWrapper";
import {Icon} from "../../atoms/Icon/Icon";
import {isDefined} from "../../../../utils/Utils";
import moment = require("moment");
import classNames = require("classnames");

interface IProps {
	/**
	 * Max available date.
	 */
	maxDate?: moment.Moment;
	/**
	 * Min available date.
	 */
	minDate?: moment.Moment;
	/**
	 * Initial date picker date.
	 */
	initialDate?: moment.Moment;
	/**
	 * Placeholder string.
	 */
	placeholder?: string;
	/**
	 * Indicates if field is disabled.
	 */
	disabled?: boolean;
	/**
	 * Indicates if input field is readonly.
	 */
	readonly?: boolean;
	/**
	 * Input on change callback.
	 */
	onDateChange?: (date?: moment.Moment) => void;
	/**
	 * Excluded dates form date picker
	 */
	excludeDates?: moment.Moment[];
	/**
	 * Date format
	 */
	dateFormat?: string;
	/**
	 * Indicates if date picker is clearable
	 */
	clearable?: boolean;
}

export default class DatePickerWithIcon extends React.Component<IProps, {}> {

	inputRef: HTMLInputElement;
	datePickerRef: any;

	constructor(props: IProps) {
		super(props);
		this.onDateChange = this.onDateChange.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	render() {

		const styleFromProps = this.props.disabled ? {cursor: "not-allowed"} : {};
		const classFromProps = classNames({
			"is-disabled": this.props.disabled,
			"is-readonly": this.props.readonly,
			"m-date-picker-with-icon": true
		});

		return (
			<div className={classFromProps} style={styleFromProps}>
				<span className={"m-date-picker-with-icon_icon-append"}>
					<IconWrapper icon={Icon.Calendar}
								 disabled={this.props.disabled}
								 size={18}
								 variant={this.isIconGray() ? "gray" : "blue"}/>
				</span>
				<DatePicker ref={dp => {this.datePickerRef = dp}}
							className={"m-date-picker-with-icon_picker-input"}
							maxDate={this.props.maxDate}
							minDate={this.props.minDate}
							openToDate={this.props.initialDate}
							selected={this.props.initialDate}
							disabled={this.props.disabled}
							placeholderText={this.props.placeholder}
							readOnly={this.props.readonly}
							calendarClassName={"m-date-picker-with-icon_calendar"}
							popperClassName={"m-date-picker-with-icon_popper"}
							onClickOutside={this.handleClickOutside}
							onChange={this.onDateChange}
							excludeDates={this.props.excludeDates}
							dateFormat={this.props.dateFormat}
							isClearable={this.props.clearable}/>
			</div>
		);
	}

	/**
	 * On date change callback.
	 * @param {moment.Moment} date
	 */
	private onDateChange(date?: moment.Moment) {
		if (!this.props.disabled && !this.props.readonly && isDefined(this.props.onDateChange)) {
			this.props.onDateChange(isDefined(date) ? moment(date).startOf("day") : date);
		}
	}

	/**
	 * Fix incompatibility with react-select, on outside click remove focus and close date-picker.
	 * It solves problem with intercepting focus events from react-select.
	 */
	private handleClickOutside() {
		this.datePickerRef.cancelFocusInput();
		this.datePickerRef.setOpen(false);
	}

	/**
	 * Indicates if icon should be grayed.
	 * @return {boolean | undefined}
	 */
	private isIconGray() {
		return (this.props.initialDate ? !this.props.initialDate.isValid() : true) || this.props.readonly || this.props.disabled;
	}
}
